import axios from "axios";

import { CrudService } from "./crud.service";
import LocalStorageKeys from "../data/localStorageKeys";

export class ClienteService extends CrudService {
    get AuthHeader() {
        return "Bearer " + localStorage.getItem(LocalStorageKeys.tokenComercio);
    }

    constructor() {
        super('sb/cliente/')
    }

    getAfiliadoByDni(dni) {
        const path = `${CrudService.api}${this.endPoint}afiliado/dni/${dni}`;
        return axios.get(path, { headers: this.Headers });
    }
}